function LoginCallback(props){

    return(<div>
        <div className={"container"}
             style={{display: "flex", justifyContent: "center", marginTop: "5rem"}}>
            <p style={{fontSize: "20px", textAlign: "center"}}>
                <strong>
                    Verifica autenticazione in corso
                </strong>
            </p>
        </div>
    </div>)
}
export default LoginCallback